<template>
    <div>
        <BookingBack title="" :textColor="'#333333'" :isCenter="true"/>
        <div class="payOrder">
            <!-- 顶部日期时间信息 -->
            <div class="dateHeader" v-if="orderData && orderData.length > 0">
                <div class="dateText">{{ formatTimestamp(orderData[0].start_time, 'MMMM, dddd DD YYYY') }}</div>
                <div class="timeText">{{ formatTimestamp(orderData[0].start_time, 'hh:mm A') }} -{{ formatTimestamp(orderData[orderData.length - 1].end_time, 'hh:mm A') }} ({{ getTotalMinutes() }}min)</div>
                <div class="shopName">{{ shopName }}</div>
            </div>
             <div class="orderList">
                <template v-for="(item, index) in orderData">
                    <PayOrderList
                        :key="'service-' + (item.id || index)"
                        :list="item"
                    />
                    <div
                        v-if="index < orderData.length - 1"
                        :key="'sep-' + index"
                        class="serviceSeparator"
                    >
                        <div class="serviceSeparatorLine"></div>
                    </div>
                </template>
                <van-divider :style="{width:'100%',color: '#333333', borderColor: '#cccccc' }"></van-divider>
                <div class="totalPrice">Total : ${{ totalPrice.toFixed(2) }}+</div>
            </div>
            <van-field v-model="queryForm.buyer_remark"  placeholder="Note (optional)"  style="margin-top:1rem;border:1px solid #CCCCCC;border-radius:8px"/>
            <van-divider :style="{ borderColor: '#CCCCCC' }" dashed></van-divider>
            <div class="payContent">
                <div style="color:#666666;margin-bottom:1rem">Select Payment Method</div>
                <div class="payMethods">
                    <div class="payItem" v-for="item in visiblePayMethods" :key="item.id" @click="queryForm.order_type = item.id">
                        <div>{{ item.label }}</div>
                        <div class="round" :class="{'active':item.id == queryForm.order_type}"></div>
                    </div>
                    <!-- Gift Card输入区域 -->
                    <div class="giftCardSection" v-if="queryForm.order_type == 3">
                        <div class="giftCardInput">
                            <input
                                type="text"
                                v-model="giftCardNo"
                                placeholder="Please enter card number"
                                class="cardInput"
                            />
                            <button class="queryBtn" @click="queryGiftCard">Search</button>
                        </div>
                        <div class="errorTip" v-if="giftCardError">
                            <span class="errorIcon">!</span>
                            <span>Invalid card number</span>
                        </div>
                        <!-- Balance显示 -->
                        <div class="balanceInfo" v-if="selectedCard">
                            <span class="balanceLabel">Balance: ${{ selectedCard.balance }}</span>
                            <button class="useBtn" @click="confirmUseCard">Use</button>
                        </div>
                        <div class="selectFromWallet" @click="selectFromWallet">
                            Select from card wallet
                        </div>
                    </div>
                    <van-field v-model="queryForm.phone"  placeholder="Please enter contact info" />
                </div>
            </div>
        </div>
        <div class="placeBox">
            <div class="placeBtn">
                <div class="btn" @click="handlePay">Confirm Order</div>
            </div>
        </div>
        <van-overlay :show="showOver">
            <div class="wrapper" @click.stop>
                <div class="block">
                    <div class="blockClose" @click="showOver = false">
                        <svg viewBox="0 0 24 24" width="20" height="20">
                            <path d="M18 6L6 18M6 6l12 12" stroke="#999" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <div class="blockHeader">
                        <div class="blockTitle">Insufficient balance</div>
                        <div class="blockSubtitle">Gift card balance is insufficient</div>
                        <div class="blockAmount">Amount due: <span class="highlight">${{ needPayMore.toFixed(2) }}</span></div>
                    </div>
                    <div class="blockPayMethods">
                        <div class="methodTitle">Select additional payment method</div>
                        <div class="methodItem" @click="extraPayType = 2" :class="{ active: extraPayType === 2 }">
                            <div>Stripe Prepay</div>
                            <div class="round" :class="{ active: extraPayType === 2 }"></div>
                        </div>
                    </div>
                    <div class="blockBtn" @click="confirmExtraPay">Continue Order</div>
                </div>
            </div>
        </van-overlay>
        <!-- 卡包选择弹窗 -->
        <van-popup
            v-model="showWalletPopup"
            round
            closeable
            position="bottom"
            :style="{ maxHeight: '70%', paddingBottom: '1rem' }"
        >
            <div class="walletPopup">
                <div class="walletTitle">Gift Card Payment</div>
                <div class="walletLoading" v-if="walletLoading">Loading...</div>
                <div class="walletEmpty" v-else-if="walletCards.length === 0">No available gift cards</div>
                <div class="walletList" v-else>
                    <div
                        class="walletCard"
                        :class="card.cardType"
                        v-for="card in walletCards"
                        :key="card.id"
                        @click="handleSelectCard(card)"
                    >
                        <div class="cardHeader">
                            <span class="cardTag">Gift Card</span>
                            <div class="cardCopy" @click.stop="copyCardNo(card.card_no)">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <rect x="9" y="9" width="10" height="10" rx="2" ry="2" fill="none" stroke="#ffffff" stroke-width="2"></rect>
                                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" fill="none" stroke="#ffffff" stroke-width="2"></path>
                                </svg>
                            </div>
                        </div>
                        <div class="cardNumber">{{ formatCardNumber(card.card_no) }}</div>
                        <div class="cardShopName">{{ card.shopName }}</div>
                        <div class="cardAddress">{{ card.address }}</div>
                        <div class="cardBottom">
                            <span class="cardLabel">Balance</span>
                            <span class="cardAmount">${{ formatBalance(card.balance) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import PayOrderList from '@/components/Pay/orderList.vue'
import myMixin from '@/utils/myMixin'
import { Toast  } from 'vant';
import { startStripeCheckout, getAbsoluteHashUrl } from '@/utils/stripeCheckout'
export default {
    name:'PayOrder',
    mixins: [myMixin],
    data(){
        return {
            totalPrice:0,
            orderData:null,
            shopName: '',
            showOver:false,
            needPayMore: 0,
            extraPayType: 2,
            giftCardNo:'',
            giftCardError:false,
            selectedCard: null,
            showWalletPopup: false,
            walletLoading: false,
            walletCards: [],
            payMethods:[
                {id:2,label:'Stripe Prepay'},
                {id:1,label:'Pay at Store'},
                {id:3,label:'Gift Card'},
                {id:4,label:'CSR Assisted Order'},
            ],
            // 当前用户信息（用于权限判断，例如 is_replace）
            currentUserInfo: null,
            queryForm:{
                buyer_remark:'',
                mobile:'',
                order_type:1,
                // service:JSON.stringify([{service_id:5,start_time:"2025-09-02 10:00:00",end_time:"2025-09-02 11:00:00",technician_id:1}])
                service:''
            },
            merchantTimezone: null
        }
    },
    components:{
        BookingBack,
        PayOrderList
    },
    mounted(){
        // 检测是否是从Stripe支付CancelBack
        if (this.$route.query.pay === 'cancel') {
            Toast.fail('Payment cancelled')
            // 跳转到订单列表页面
            this.$router.replace('/order?pay=cancel')
            return
        }
        // 读取缓存的用户信息；如果没有就补拉一次
        this.loadCurrentUserInfo()
        try {
            const parsed = JSON.parse(this.$route.query.orderData) || []
            if (Array.isArray(parsed) && parsed.length > 1) {
                parsed.sort((a, b) => this.parseTime(a.start_time) - this.parseTime(b.start_time))
            }
            this.orderData = parsed
        } catch (e) {
            this.orderData = []
        }
        // 获取Store Name
        if (this.orderData && this.orderData.length > 0 && this.orderData[0].shop_supplier_id) {
            this.getShopName(this.orderData[0].shop_supplier_id)
        }
    },
    computed: {
        // is_replace: 0=普通用户（不展示CSR Assisted Order），1=客服（展示）
        visiblePayMethods() {
            const isReplace = this.currentUserInfo && typeof this.currentUserInfo.is_replace !== 'undefined' ? Number(this.currentUserInfo.is_replace)
                : 0
            const allowServiceOrder = isReplace === 1
            return allowServiceOrder ? this.payMethods : this.payMethods.filter(m => m.id !== 4)
        }
    },
    watch:{
        orderData: {
            handler(newVal, oldVal) {
                this.totalPrice = 0
                for(let i in newVal ){
                    this.totalPrice += Number(newVal[i].price) || Number(newVal[i].total_price)
                }
            },
            deep: true, // 深度监听
            // immediate: true // 初始化时立即执行一次
        },
        'queryForm.order_type': {
            handler(newVal) {
                // 切换Payment Method时清空礼品卡信息
                if (newVal !== 3) {
                    this.giftCardNo = ''
                    this.giftCardError = false
                    this.selectedCard = null
                }
            }
        }
    },
    methods:{
        loadCurrentUserInfo() {
            // 先读本地缓存
            try {
                const cached = localStorage.getItem('userInfo')
                if (cached) {
                    this.currentUserInfo = JSON.parse(cached)
                }
            } catch (e) {
                // ignore
            }
            // 如果没有缓存，再请求一次
            if (!this.currentUserInfo) {
                this.$api.getUserDetail().then(res => {
                    if (res && res.code === 1 && res.data) {
                        this.currentUserInfo = res.data.userInfo || {}
                        try {
                            localStorage.setItem('userInfo', JSON.stringify(this.currentUserInfo || {}))
                            localStorage.setItem('userDetail', JSON.stringify(res.data || {}))
                        } catch (e) {
                            // ignore
                        }
                        // 如果当前选中了“CSR Assisted Order”但用户无权限，则回退到“Pay at Store”
                        if (Number(this.currentUserInfo.is_replace) !== 1 && this.queryForm.order_type === 4) {
                            this.queryForm.order_type = 1
                        }
                    }
                }).catch(() => {})
            } else {
                // 已有缓存，也做一次兜底回退
                if (Number(this.currentUserInfo.is_replace) !== 1 && this.queryForm.order_type === 4) {
                    this.queryForm.order_type = 1
                }
            }
        },
        parseTime(time) {
            if (!time) return 0
            if (typeof time === 'number') {
                return time.toString().length === 10 ? time * 1000 : time
            }
            if (typeof time === 'string') {
                const timestamp = new Date(time).getTime()
                return isNaN(timestamp) ? 0 : timestamp
            }
            return 0
        },
        getTotalMinutes() {
            if (!this.orderData || this.orderData.length === 0) return 0
            let totalMin = 0
            for (let item of this.orderData) {
                let min = item.minute || 0
                if (item.hour > 0) {
                    min += item.hour * 60
                }
                totalMin += min
            }
            return totalMin
        },
        async getShopName(shop_supplier_id) {
            try {
                const res = await this.$api.getSupplierDetail({ shop_supplier_id })
                if (res.code === 1 && res.data && res.data.detail) {
                    this.shopName = res.data.detail.name || ''
                    this.merchantTimezone = res.data.detail.timezone || null
                }
            } catch (e) {
                console.error('Failed to get store name:', e)
            }
        },
        // 转换时间为接口需要的秒级时间戳
        formatTimeForApi(time) {
            if (!time) return ''
            if (typeof time === 'number') {
                return time.toString().length === 13 ? Math.floor(time / 1000) : time
            }
            if (/^\d+$/.test(String(time))) {
                const timestamp = Number(time)
                return String(time).length === 13 ? Math.floor(timestamp / 1000) : timestamp
            }
            if (this.merchantTimezone) {
                const ts = this.localTimeToTimestamp(String(time), this.merchantTimezone)
                if (ts !== null) return ts
            }
            const timestamp = new Date(String(time).replace(/-/g, '/')).getTime()
            if (isNaN(timestamp)) {
                return time
            }
            return Math.floor(timestamp / 1000)
        },
        formatCardNumber(cardNo) {
            if (!cardNo) return ''
            return cardNo.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
        },
        formatBalance(balance) {
            const num = Number(balance || 0)
            return num.toFixed(2)
        },
        copyCardNo(cardNo) {
            if (!cardNo) return
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(cardNo).then(() => {
                    Toast.success('Card number copied')
                })
            } else {
                const input = document.createElement('input')
                input.value = cardNo
                document.body.appendChild(input)
                input.select()
                document.execCommand('copy')
                document.body.removeChild(input)
                Toast.success('Card number copied')
            }
        },
        queryGiftCard(){
            if(!this.giftCardNo){
                this.giftCardError = true
                return
            }
            this.giftCardError = false
            this.selectedCard = null
            // 调用搜索礼品卡接口
            this.$api.getUserGiftCardList({}).then(res => {
                if (res.code === 1 && res.data && res.data.data) {
                    const list = res.data.data
                    const found = list.find(item => {
                        const cardNo = item.giftCardInstance?.card_no || ''
                        return cardNo === this.giftCardNo.replace(/\s/g, '')
                    })
                    if (found) {
                        const instance = found.giftCardInstance || {}
                        const giftCard = instance.giftCard || {}
                        this.selectedCard = {
                            id: found.id,
                            binding_id: found.id,
                            card_no: instance.card_no,
                            balance: instance.balance || instance.initial_value || 0,
                            alias: found.alias || giftCard.name || 'Gift Card'
                        }
                    } else {
                        this.giftCardError = true
                    }
                } else {
                    this.giftCardError = true
                }
            }).catch(() => {
                this.giftCardError = true
            })
        },
        selectFromWallet(){
            this.showWalletPopup = true
            this.fetchWalletCards()
        },
        async fetchWalletCards() {
            this.walletLoading = true
            try {
                const res = await this.$api.getUserGiftCardList({ shop_supplier_id: 1 })
                if (res.code === 1 && res.data && res.data.data) {
                    this.walletCards = res.data.data.map((item, index) => {
                        const instance = item.giftCardInstance || {}
                        const giftCard = instance.giftCard || {}
                        const supplier = giftCard.supplier || {}
                        return {
                            id: item.id,
                            binding_id: item.id,
                            card_no: instance.card_no || '',
                            balance: instance.balance || instance.initial_value || 0,
                            alias: item.alias || giftCard.name || 'Gift Card',
                            name: giftCard.name || '',
                            shopName: supplier.name || item.alias || giftCard.name || 'Store Name',
                            address: supplier.address || '',
                            cardType: index % 2 === 0 ? 'green-card' : 'blue-card'
                        }
                    })
                } else {
                    this.walletCards = []
                }
            } catch (error) {
                this.walletCards = []
                Toast.fail('Failed to load gift card list')
            } finally {
                this.walletLoading = false
            }
        },
        async handleSelectCard(card) {
            // 点击卡片后请求详情接口
            try {
                const res = await this.$api.getUserGiftCardDetail({
                    binding_id: card.binding_id,
                    card_no: card.card_no,
                    shop_supplier_id: 1
                })
                if (res.code === 1 && res.data && res.data.data && res.data.data.length > 0) {
                    const detail = res.data.data[0]
                    const instance = detail.giftCardInstance || {}
                    const giftCard = instance.giftCard || {}
                    // 回填卡号andBalance
                    this.giftCardNo = instance.card_no || card.card_no
                    this.selectedCard = {
                        id: detail.id,
                        binding_id: detail.id,
                        card_no: instance.card_no,
                        balance: instance.balance || instance.initial_value || 0,
                        alias: detail.alias || giftCard.name || 'Gift Card'
                    }
                    this.giftCardError = false
                } else {
                    // 如果详情接口没返回数据，使用列表数据
                    this.giftCardNo = card.card_no
                    this.selectedCard = card
                    this.giftCardError = false
                }
            } catch (error) {
                // 请求失败时使用列表数据
                this.giftCardNo = card.card_no
                this.selectedCard = card
                this.giftCardError = false
            }
            this.showWalletPopup = false
        },
        confirmUseCard() {
            if (this.selectedCard) {
                Toast.success('Gift card selected')
            }
        },
        handlePay(){
            let arr = []
            let data = this.orderData
            if (!data || data.length === 0) {
                Toast.fail('Please select service items')
                return
            }
            for( let i in data ){
                const item = data[i]
                const technicianId = item.technician ? item.technician.id : (item.technician_id || 0)
                // 转换时间格式为 Y-m-d H:i:s
                const startTime = this.formatTimeForApi(item.start_time)
                const endTime = this.formatTimeForApi(item.end_time)
                arr.push({
                    service_id: item.id || item.service_id,
                    technician_id: technicianId,
                    start_time: startTime,
                    end_time: endTime
                })
            }
            this.queryForm.service = JSON.stringify(arr)
            // 如果是礼品卡 Payment，检查余额是否足够
            if (this.queryForm.order_type === 3) {
                if (!this.selectedCard) {
                    Toast.fail('Please select a gift card')
                    return
                }
                const cardBalance = Number(this.selectedCard.balance) || 0
                if (cardBalance < this.totalPrice) {
                    // Insufficient balance，显示弹窗
                    this.needPayMore = this.totalPrice - cardBalance
                    this.showOver = true
                    return
                }
            }
            // 直接下单
            this.submitOrder()
        },
        // 确认补充支付
        confirmExtraPay() {
            this.showOver = false
            this.submitOrder(true)
        },
        // 提交订单
        submitOrder(isExtraPay = false) {
            // 构建请求参数
            let params = {
                buyer_remark: this.queryForm.buyer_remark || '',
                mobile: this.queryForm.mobile || '',
                order_type: this.queryForm.order_type,
                service: this.queryForm.service
            }
            // 如果是礼品卡 Payment，Add 礼品卡相关参数
            if (this.queryForm.order_type === 3) {
                params.gift_card_number = this.selectedCard.card_no
                params.gift_card_instance_id = this.selectedCard.id
                // 如果需要补充支付
                if (isExtraPay) {
                    params.extra_pay_type = this.extraPayType
                    params.extra_pay_amount = this.needPayMore
                }
            }
            // Stripe Checkout：后端需要 success_url/cancel_url（绝对 URL）
            const isStripeMain = Number(this.queryForm.order_type) === 2
            const isStripeExtra =
                Number(this.queryForm.order_type) === 3 &&
                isExtraPay &&
                Number(this.extraPayType) === 2
            if (isStripeMain || isStripeExtra) {
                params.success_url = getAbsoluteHashUrl('/order?pay=success')
                params.cancel_url = getAbsoluteHashUrl('/order?pay=cancel')
            }
            this.$api.payOrder(params).then(res=>{
                if(res.code == 1){
                    // Stripe：后端返回 checkout_session_id 或 checkout_url 时，跳转 Stripe Checkout
                    const payload = res || {}
                    const sessionId =
                        payload.checkout_session_id ||
                        payload.checkoutSessionId ||
                        payload.data?.checkout_session_id ||
                        payload.data?.checkoutSessionId
                    const checkoutUrl =
                        payload.checkout_url ||
                        payload.checkoutUrl ||
                        payload.url ||
                        payload.data?.checkout_url ||
                        payload.data?.checkoutUrl ||
                        payload.data?.url
                    if (isStripeMain || isStripeExtra) {
                        if (sessionId || checkoutUrl) {
                            Toast.loading({ duration: 0, message: 'Redirecting to payment...', forbidClick: true })
                            startStripeCheckout({ checkoutUrl, sessionId })
                              .catch((e) => {
                                  console.error('Stripe redirect error:', e)
                                  Toast.clear()
                                  Toast.fail((e && e.message) || 'Failed to redirect to payment')
                              })
                            return
                        } else {
                            // 需要 Stripe 支付但后端没有返回 checkout 信息
                            console.error('Stripe payment required, but backend did not return checkout_session_id or checkout_url.')
                            Toast.fail('Failed to get payment info. Please try again.')
                            return
                        }
                    }
                    Toast.success('Order placed successfully')
                    // 跳转到个人中心的Book页面
                    this.$router.push('/order')
                }else{
                    Toast.fail(res.msg || 'Order failed')
                }
            }).catch(err => {
                console.error('Order failed:', err)
                Toast.fail('Network error. Please try again.')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .dateHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1rem 0 1.5rem 0;
        .dateText {
            font-size: 1.125rem;
            font-weight: 500;
            color: #333;
        }
        .timeText {
            font-size: 1rem;
            color: #666;
            margin: 0.5rem 0;
        }
        .shopName {
            font-size: 0.875rem;
            color: #999;
        }
    }
    .totalPrice {
        text-align: right;
        font-weight: bold;
        color: #333;
    }
    .orderList{
        width: 100%;
        padding: 1rem;
        background: #F4F4F4;
        box-sizing: border-box;
        border-radius: .625rem;
    }
    .serviceSeparator{
        padding: 0.75rem 0;
    }
    .serviceSeparatorLine{
        width: 100%;
        height: 1px;
        background: #D6D6D6;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .block {
        width: 85%;
        height: auto;
        background-color: #fff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-sizing: border-box;
        position: relative;
        .blockClose {
            position: absolute;
            top: 1rem;
            right: 1rem;
            width: 1.5rem;
            height: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
        .blockHeader {
            text-align: left;
            margin-bottom: 1.5rem;
            .blockTitle {
                font-size: 1.125rem;
                font-weight: 600;
                color: #333;
                margin-bottom: 0.5rem;
            }
            .blockSubtitle {
                font-size: 0.875rem;
                color: #666;
                margin-bottom: 0.75rem;
            }
            .blockAmount {
                font-size: 0.875rem;
                color: #333;
                .highlight {
                    color: #1E3C3E;
                    font-size: 1.25rem;
                    font-weight: 600;
                }
            }
        }
        .blockPayMethods {
            margin-bottom: 1.5rem;
            background: #F8F8F8;
            border-radius: 0.5rem;
            padding: 1rem;
            .methodTitle {
                font-size: 0.875rem;
                color: #666;
                margin-bottom: 0.75rem;
            }
            .methodItem {
                width: 100%;
                height: 3rem;
                background: #fff;
                border-radius: 0.5rem;
                margin-bottom: 0.5rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 1rem;
                box-sizing: border-box;
                cursor: pointer;
                &:last-child {
                    margin-bottom: 0;
                }
                .round {
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 100%;
                    background: #fff;
                    border: 2px solid #D9D9D9;
                    box-sizing: border-box;
                    &.active {
                        border: 5px solid #1E3C3E;
                    }
                }
            }
        }
        .blockBtn {
            width: 100%;
            height: 2.75rem;
            background: #1E3C3E;
            border-radius: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 0.875rem;
            cursor: pointer;
        }
    }
    .placeBox{
        width: 100%;
        height: 3.75rem;
        .placeBtn{
            width: 100%;
            height:3.75rem;
            position: fixed;
            bottom: 0;
            background: #fff;
            padding: 0 1rem;
            box-sizing: border-box;
            .btn{
                width: 100%;
                height: 2.75rem;
                background: #1E3C3E;
                border-radius: .25rem;
                display: flex;
                align-items:center;
                justify-content: center;
                color: #fff;
                font-size: .875rem;
            }
        }
    }
    .payOrder{
        width: 100%;
        padding:1rem;
        box-sizing: border-box;
        .dateGroup{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 1.25rem;
            .year{
                color: #333333;
                font-weight: bold;
            }
            .time{
                color: #666666;
                margin: 0.5rem;
            }
            .serviceName{
                color: #999999;
                font-size: .875rem;
            }
        }
        .payContent{
            width: 100%;
            background: #F4F4F4;
            border-radius: .5rem;
            padding: 1rem;
            box-sizing: border-box;
            .payMethods{
                display: flex;
                flex-direction: column;
                .payItem{
                    width: 100%;
                    height: 2.5rem;
                    background: #fff;
                    border-radius: .25rem;
                    margin-bottom: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 1rem;
                    box-sizing: border-box;
                    .round{
                        width: 1rem;
                        height: 1rem;
                        border-radius: 100%;
                        background: #fff;
                        border:1px solid #D9D9D9;
                        box-sizing: border-box;
                    }
                    .active{
                        border:4px solid #1E3C3E;
                    }
                }
                .giftCardSection{
                    width: 100%;
                    background: #fff;
                    border-radius: .75rem;
                    padding: 1rem;
                    box-sizing: border-box;
                    margin-bottom: 1rem;
                    .giftCardInput{
                        display: flex;
                        align-items: center;
                        gap: .75rem;
                        .cardInput{
                            flex: 1;
                            height: 2.75rem;
                            border: 1px solid #CCCCCC;
                            border-radius: .5rem;
                            outline: none;
                            padding: 0 1rem;
                            font-size: .875rem;
                            background: #fff;
                            &::placeholder{
                                color: #999;
                            }
                        }
                        .queryBtn{
                            width: 4rem;
                            height: 2.75rem;
                            background: #1E3C3E;
                            border: none;
                            border-radius: .5rem;
                            color: #fff;
                            font-size: .875rem;
                            cursor: pointer;
                            flex-shrink: 0;
                        }
                    }
                    .errorTip{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: .75rem;
                        color: #E8A740;
                        font-size: .875rem;
                        .errorIcon{
                            width: 1rem;
                            height: 1rem;
                            border: 1px solid #E8A740;
                            border-radius: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-right: .375rem;
                            font-size: .75rem;
                        }
                    }
                    .selectFromWallet{
                        width: 100%;
                        height: 2.75rem;
                        border: 1px solid #CCCCCC;
                        border-radius: .5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 1rem;
                        color: #333;
                        font-size: .875rem;
                        cursor: pointer;
                        background: #fff;
                    }
                    .balanceInfo{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: .75rem;
                        padding: .75rem 1rem;
                        background: #F8F8F8;
                        border-radius: .5rem;
                        border: 1px solid #E5E8E6;
                        .balanceLabel{
                            font-size: .875rem;
                            font-weight: 600;
                            color: #1E3C3E;
                        }
                        .useBtn{
                            min-width: 4rem;
                            height: 2rem;
                            background: #1E3C3E;
                            border: none;
                            border-radius: .5rem;
                            color: #fff;
                            font-size: .875rem;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    // 卡包弹窗样式
    .walletPopup{
        padding: 1rem;
        .walletTitle{
            font-size: 1rem;
            font-weight: 500;
            color: #333;
            text-align: left;
            margin-bottom: 1rem;
            padding-top: .5rem;
        }
        .walletLoading,
        .walletEmpty{
            text-align: center;
            color: #999;
            padding: 2rem 0;
        }
        .walletList{
            max-height: 55vh;
            overflow-y: auto;
        }
        .walletCard{
            border-radius: 1rem;
            padding: 1.25rem;
            margin-bottom: 1rem;
            color: #fff;
            position: relative;
            overflow: hidden;
            // 绿色卡片
            &.green-card{
                background: linear-gradient(135deg, #1a4d3e 0%, #2d6b5a 50%, #1a4d3e 100%);
            }
            // 蓝色卡片
            &.blue-card{
                background: linear-gradient(135deg, #1e3a5f 0%, #2a4a6d 50%, #1e3a5f 100%);
            }
            // 发光效果
            &::before {
                content: '';
                position: absolute;
                top: 30%;
                left: 20%;
                width: 120px;
                height: 120px;
                background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
                pointer-events: none;
            }
            .cardHeader{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: .75rem;
                position: relative;
                z-index: 1;
                .cardTag{
                    font-size: .875rem;
                    font-weight: 500;
                    color: rgba(255,255,255,0.9);
                }
                .cardCopy{
                    width: 2rem;
                    height: 2rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    opacity: 0.8;
                    &:active{
                        opacity: 1;
                    }
                }
            }
            .cardNumber{
                font-size: 1.25rem;
                font-weight: 600;
                letter-spacing: 2px;
                margin-bottom: 1rem;
                position: relative;
                z-index: 1;
            }
            .cardShopName{
                font-size: 1rem;
                font-weight: 600;
                margin-bottom: .25rem;
                position: relative;
                z-index: 1;
            }
            .cardAddress{
                font-size: .75rem;
                color: rgba(255,255,255,0.7);
                margin-bottom: 1rem;
                position: relative;
                z-index: 1;
            }
            .cardBottom{
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;
                z-index: 1;
                .cardLabel{
                    font-size: .75rem;
                    color: rgba(255,255,255,0.8);
                }
                .cardAmount{
                    font-size: 1.5rem;
                    font-weight: 700;
                }
            }
        }
    }
</style>
